import type {
  Configuration,
  CreateSamlIdentityProviderConfigInput,
  UpdateSamlIdentityProviderInput,
} from '@repo/api-gw-sdk';
import {
  ListSamlIdentityProviderConfigsApi,
  CreateSamlIdentityProviderConfigApi,
  DeleteSamlIdentityProviderConfigApi,
  UpdateSamlIdentityProviderConfigOverrideApi,
  GetServiceProviderDetailsApi,
} from '@repo/api-gw-sdk';

import type { HttpClient } from './httpClient';

const baseUrl = '/samlIdentityProvider';

export const saml = (httpClient: HttpClient, config: Configuration) => {
  const listSamlIdentityProviderConfigsApi =
    new ListSamlIdentityProviderConfigsApi(config);
  const createSamlIdentityProviderConfigApi =
    new CreateSamlIdentityProviderConfigApi(config);
  const updateSamlIdentityProviderConfigOverrideApi =
    new UpdateSamlIdentityProviderConfigOverrideApi(config);
  const deleteSamlIdentityProviderConfigApi =
    new DeleteSamlIdentityProviderConfigApi(config);
  const getServiceProviderDetailsApi = new GetServiceProviderDetailsApi(config);

  return {
    useList: (enabled = true) =>
      httpClient.execute(
        listSamlIdentityProviderConfigsApi.listSamlIdentityProviderConfigs.bind(
          listSamlIdentityProviderConfigsApi
        ),
        enabled ? baseUrl : null,
        ''
      ),
    create: (saml: CreateSamlIdentityProviderConfigInput) =>
      createSamlIdentityProviderConfigApi.createSamlIdentityProviderConfig(
        saml
      ),
    update: (id: string, saml: UpdateSamlIdentityProviderInput) =>
      updateSamlIdentityProviderConfigOverrideApi.updateSamlConfigOverride(
        id,
        saml
      ),
    delete: (id: string) =>
      deleteSamlIdentityProviderConfigApi.deleteSamlIdentityProviderConfig(id),
    useServiceProviderDetails: (enabled = true, providerName?: string) =>
      httpClient.execute(
        getServiceProviderDetailsApi.getServiceProviderDetails.bind(
          getServiceProviderDetailsApi
        ),
        enabled ? baseUrl : null,
        'service-provider-details',
        providerName
      ),
  };
};
